import React from 'react';
import { Switch, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthRoute from '../AuthRoute';
import ApprovalSubmitted from '../components/dashboardHub/ApprovalSubmitted';
import ViewConfirmInstallation from '../components/dashboardHub/ViewConfirmInstallation';

const Dashboard = loadable(() =>
  import('../components/dashboardHub/Dashboard')
);
const ApplicationWithrawal = loadable(() =>
  import('../components/dashboardHub/ApplicationWithdrawal')
);
const WithdrawConfirm = loadable(() =>
  import('../components/dashboardHub/WithdrawConfirm')
);
const ViewGrantApplication = loadable(() =>
  import('../components/dashboardHub/ViewGrantApplication')
);
const ViewApplicationSentToInstaller = loadable(() =>
  import('../components/dashboardHub/ViewApplicationSentToInstaller')
);
const ViewApplicationCompleted = loadable(() =>
  import('../components/dashboardHub/ViewApplicationCompleted')
);
const ViewAppCompleted = loadable(() =>
  import('../components/dashboardHub/ViewAppCompleted')
);
const ViewApplicationApproved = loadable(() =>
  import('../components/dashboardHub/ViewApplicationApproved')
);
const ViewApplicationDeclined = loadable(() =>
  import('../components/dashboardHub/ViewApplicationDeclined')
);
const ViewAppDeclined = loadable(() =>
  import('../components/dashboardHub/ViewAppDeclined')
);
const ViewApplicationSubmittedByInstaller = loadable(() =>
  import('../components/dashboardHub/ViewApplicationSubmittedByInstaller')
);
const ViewApplicationSubmittedForReview = loadable(() =>
  import('../components/dashboardHub/ViewApplicationSubmittedForReview')
);
const YourAccount = loadable(() =>
  import('../components/dashboardHub/YourAccount')
);

export default function RoutesTreeDashboard() {
  return (
    <Switch>
      {/* ***************** */}
      {/* dashboard routes  */}
      {/* ***************** */}
      <AuthRoute exact path="/dashboardHub/dashboard">
        <Dashboard />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/application-withdrawal">
        <ApplicationWithrawal />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/withdraw-confirm">
        <WithdrawConfirm />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/view-grant-application/:id">
        <ViewGrantApplication />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/view-application-sent-to-installer">
        <ViewApplicationSentToInstaller />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/view-application-completed">
        <ViewApplicationCompleted />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/completed/:id">
        <ViewAppCompleted />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/approved-for-payment/:id">
        <ViewApplicationApproved />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/completed/:id">
        <ViewAppCompleted />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/view-application-declined">
        <ViewApplicationDeclined />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/declined/:id">
        <ViewAppDeclined />
      </AuthRoute>
      <AuthRoute
        exact
        path="/dashboardHub/view-application-submitted-by-installer"
      >
        <ViewApplicationSubmittedByInstaller />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/submitted-for-review/:id">
        <ViewApplicationSubmittedForReview />
      </AuthRoute>
      <AuthRoute exact path="/dashboardHub/your-account">
        <YourAccount />
      </AuthRoute>
      <Route exact path="/dashboardHub/confirm-installation">
        <ViewConfirmInstallation />
      </Route>
      <Route exact path="/landlordApp/approval-submitted">
        <ApprovalSubmitted />
      </Route>
    </Switch>
  );
}
